import { UserService } from '@shared/services/user.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '@shared/models/login.model';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';

@Component({
  selector: 'app-switch-dashboard',
  templateUrl: './switch-dashboard.component.html',
  styleUrls: ['./switch-dashboard.component.scss']
})
export class SwitchDashboardComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  public selectorActive = false;
  public dashboardActive: string;
  public user: IUser;

  constructor(private router: Router, private userService: UserService) {
    super();
    this.user = this.userService.userInfo;
    const url = window.location.pathname.split('/');
    this.dashboardActive = url[url.length - 1];
  }

  ngOnInit() {
    this.subs.add(
      this.router.events.subscribe((event: any) => {
        if (event.url && event.url.indexOf('dashboard/') != -1) {
          const url = event.url.split('/');
          this.dashboardActive = url[url.length - 1];
        }
      })
    );
  }

  changeDashboard(dashboard) {
    this.router.navigate(['/main/dashboard/' + dashboard]);
  }

  getDashboardActive(position: number, isOnlyText: boolean = false) {
    let newDashboard = 'customer';
    if (this.user.role.name === 'super_admin') {
      if (this.dashboardActive === 'super_admin') {
        if (position === 1) {
          newDashboard = isOnlyText ? 'Super Admin' : 'super_admin';
        } else {
          newDashboard = isOnlyText ? 'Customer' : 'customer';
        }
      } else if (this.dashboardActive === 'customer') {
        if (position === 1) {
          newDashboard = isOnlyText ? 'Customer' : 'customer';
        } else {
          newDashboard = isOnlyText ? 'Super Admin' : 'super_admin';
        }
      }
    }
    if (this.user.role.name === 'sales_rep') {
      if (this.dashboardActive === 'sales_rep') {
        if (position === 1) {
          newDashboard = isOnlyText ? 'Sales Representative' : 'sales_rep';
        } else {
          newDashboard = isOnlyText ? 'Customer' : 'customer';
        }
      } else if (this.dashboardActive === 'customer') {
        if (position === 1) {
          newDashboard = isOnlyText ? 'Customer' : 'customer';
        } else {
          newDashboard = isOnlyText ? 'Sales representative' : 'sales_rep';
        }
      }
    }
    return newDashboard;
  }
}
